import React, {useCallback, useEffect, useRef, useState} from 'react';
import Sort from "./Sort";
import NoImage from "../../../resources/icon/noImage.png";
import EmptyData from "../../../resources/icon/empty-data.png";
import {useNavigate} from "react-router-dom";
import {getFirstField, isEmpty, isExcluded, isSystem, formatSimmsGridCell, formatSimmsDateTime} from "../../commonmethod/CommonMethod";
import {RatedStart} from "../../../packages/serviceRequest/serviceRequest/subpage/ServiceStarRating";
import Pin from "../../../resources/icon/pin.png";
import FilledPin from "../../../resources/icon/pin-filled.png";
import AvailablePin from "../../../resources/icon/pin-available.png";
import {useDispatch, useSelector} from "react-redux";
import {openDrawer} from "../../../redux/slice/opnerSlice";
import ContentsDrawer from "../../drawer/ContentsDrawer";
import HeaderModifier from "../HeaderModifier";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faRedo} from "@fortawesome/free-solid-svg-icons";
import {resetIndividualSetting} from "../../../api/user/UserAccountService";

function SimmsTable({ header, excludeArray, data, checked, page, url, pin, handleSortChange, height, entity, hasFixedBar}) {
    const IMG_BASE = import.meta.env.VITE_IMG_BASE;
    const navigate = useNavigate();
    const [isHeaderChecked, setIsHeaderChecked] = useState(false);
    const [currentColumns, setCurrentColumns] = useState(header.order);
    const [pinned,setPinned] = useState(true );
    const [filterOpen, setFilterOpen] = useState(false);
    const [selectedId,setSelectedId]= useState(0);
    const [containerWidth, setContainerWidth] = useState(0);
    const tableContainerRef = useRef(null);
    const dispatch = useDispatch();

    const settings = localStorage.getItem("setting");
    const manage = JSON.parse(settings)?.find(e => e.globalsNmAsSnake === "listManagementControl");
    const listManage = manage && manage.globalsValue ? manage.globalsValue === "true" : false;
    const user = useSelector(state =>state.auth.user);


    useEffect(() => {
        setCurrentColumns(header.order);
    }, [header]);

    useEffect(() => {
        const updateVh = () => {
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        };

        // 초기 실행
        updateVh();

        // 리사이즈 이벤트 리스너 등록
        window.addEventListener('resize', updateVh);

        // 클린업
        return () => {
            window.removeEventListener('resize', updateVh);
        };
    }, []);

    useEffect(() => {
    }, [pinned]);

    useEffect(() => {
        const node = tableContainerRef.current;
        if (!node) return;

        const updateContainerWidth = () => {
            const width = node.clientWidth ?? 0;
            setContainerWidth(width);
        };

        updateContainerWidth();

        if (typeof ResizeObserver !== "undefined") {
            const observer = new ResizeObserver(() => updateContainerWidth());
            observer.observe(node);
            return () => observer.disconnect();
        }

        window.addEventListener('resize', updateContainerWidth);
        return () => window.removeEventListener('resize', updateContainerWidth);
    }, []);


    useEffect(() => {
        if (checked && checked.required) {
            const ids = data.map(item => item.id);
            checked.setChecked([...ids]);
        }

        if(data.length == 0){
            setIsHeaderChecked(false);
        }
    }, [data]);

    const handleHeaderCheckboxClick = () => {
        setIsHeaderChecked(prev => !prev);
        if (!isHeaderChecked) {
            const currentPageIds = data.map((item) => item.id);
            checked.setChecked((prevItems) => [...new Set([...prevItems, ...currentPageIds])]);
        } else {
            const currentPageIds = data.map((item) => item.id);
            checked.setChecked((prevItems) => prevItems.filter((item) => !currentPageIds.includes(item)));
        }
    };

    const handleCheckboxClick = (value) => {
        const isChecked = checked.checked && checked.checked.includes(value);
        if (isChecked) {
            checked.setChecked((prevItems) => prevItems.filter((item) => item !== value));
        } else {
            checked.setChecked((prevItems) => [...prevItems, value]);
        }
        updateHeaderChkbox();
    };

    function updateHeaderChkbox() {
        if (checked && data && data.length > 0) {
            const allChecked = data.every((item) => checked.checked.includes(item.id));
            setIsHeaderChecked(allChecked);
        } else {
            setIsHeaderChecked(false);
        }
    }

    const goTo = (id, linkUrl, event) => {
        if (event.ctrlKey && entity === 'asset') {
            setSelectedId(id)
            dispatch(openDrawer({key: 'ContentsDrawer'}))
        }else{
            if (linkUrl) {
                navigate(`${linkUrl}`);
                return;
            }
            if(isEmpty(url)) return
            navigate(`${url}/${id}`);
        }
    };


    function getNestedValue(obj, path, short) {
        return path.split('.').reduce((acc, part) => {
            if (Array.isArray(acc)) {
                if (short) {
                    const [firstCount, unit] = short;
                    const first = acc.slice(0, firstCount).map(item => item[part]).join(', ');
                    const count = acc.length - firstCount;
                    return count > 0 ? `${first} 외 ${count}${unit}` : first;
                }
                return acc.map(item => item[part]).join(', ');
            }
            return acc && acc[part];
        }, obj);
    }

    function getInnerObject(obj, path, short) {
        const objName = path.split('.')[0];
        return obj[objName];
    }

    const moveByLink = (item, path, linkId, short) => {
        if (path && linkId) {
            navigate(`${path}/${getNestedValue(item, linkId, short)}`);
        } else if (path) {
            navigate(`${getNestedValue(item, path, short)}`);
        }
    }


    const handleDragStart = (e, columnIndex) => {
        setIsHeaderChecked(false);
        e.dataTransfer.setData('columnIndex', columnIndex);
    };

    const allowDrop= (e, columnIndex) =>  {
        e.preventDefault();
    }

    const handleDragOver = (e, columnIndex) => {
        e.preventDefault();
        const dragIndex = e.dataTransfer.getData('columnIndex');
        if (dragIndex !== columnIndex) {
            const newColumns = [...currentColumns];
            const [draggedColumn] = newColumns.splice(dragIndex, 1);
            newColumns.splice(columnIndex, 0, draggedColumn);
            setCurrentColumns(newColumns);
            setPinned(false);
        }
    };

    const headerHandler =()=>{
        if(header !== currentColumns){
            if(window.confirm("변경 내용을 저장하시겠습니까?")) {
                const updatedOrder = currentColumns.map((col) => col.field);
                const updatedWidths = currentColumns.reduce((acc, col) => {
                    const width = Number(col?.width);
                    if (Number.isFinite(width) && width > 0) {
                        acc[getFirstField(col.field)] = Math.round(width);
                    }
                    return acc;
                }, {});

                pin.onChange({
                    headers: {
                        [entity]: {
                            orders: updatedOrder,
                            excluded: excludeArray.target,
                            widths: updatedWidths
                        }
                    }
                }).then(r => {
                    if (r.status === 200) {
                        alert('저장되었습니다.');
                        setPinned(true);
                    }
                })
            }
        }
    }

    // 테이블 헤더 리사이징
    const tableRef = useRef(null);
    const resizingRef = useRef({
        active: false,
        field: null,
        startX: 0,
        startWidth: 0,
    });

    const getMinWidth = useCallback((field) => {
        const col = currentColumns.find(c => c.field === field);
        return (col?.minWidth ?? 80);
    }, [currentColumns]);

    const getWidth = useCallback((field) => {
        const col = currentColumns.find(c => c.field === field);
        return (col?.width ?? col?.minWidth ?? 120);
    }, [currentColumns]);

    const setWidthByField = useCallback((field, widthPx) => {
        setCurrentColumns(cols => cols.map(c =>
            c.field === field ? { ...c, width: Math.max(getMinWidth(field), Math.round(widthPx)) } : c
        ));
    }, [getMinWidth]);

    const onResizeMove = useCallback((e) => {
        const { active, field, startX, startWidth } = resizingRef.current;
        if (!active || !field) return;
        const delta = e.clientX - startX;
        setWidthByField(field, startWidth + delta);
    }, [setWidthByField]);

    const onResizeEnd = useCallback(() => {
        if (!resizingRef.current.active) return;
        resizingRef.current.active = false;
        setPinned(false);
        document.removeEventListener('mousemove', onResizeMove);
        document.removeEventListener('mouseup', onResizeEnd);
        document.body.style.cursor = '';
        document.body.style.userSelect = '';
    }, [onResizeMove]);

    const onResizeStart = useCallback((e, field) => {
        e.stopPropagation();     // 헤더 재정렬 드래그와 충돌 방지
        e.preventDefault();
        resizingRef.current = {
            active: true,
            field,
            startX: e.clientX,
            startWidth: getWidth(field),
        };
        document.addEventListener('mousemove', onResizeMove);
        document.addEventListener('mouseup', onResizeEnd);
        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';
    }, [getWidth, onResizeMove, onResizeEnd]);

    useEffect(() => {
        if (!containerWidth || containerWidth <= 0) return;

        const visible = currentColumns.filter((column) => !isExcluded(column.field, excludeArray.target));
        if (!visible.length) return;

        const hasWidth = visible.some((column) => {
            const width = Number(column?.width);
            return Number.isFinite(width) && width > 0;
        });
        if (hasWidth) return;

        const fixedColumnsWidth = 60 + (checked ? 40 : 0); // No. + checkbox
        const availableWidth = Math.max(containerWidth - fixedColumnsWidth, 0);
        if (availableWidth <= 0) return;

        const minWidths = visible.map((column) => Number(column?.minWidth ?? 80));
        const minTotal = minWidths.reduce((sum, width) => sum + width, 0);
        const targetWidth = Math.max(availableWidth, minTotal);
        const extra = targetWidth - minTotal;
        const q = Math.floor(extra / visible.length);
        const r = extra % visible.length;

        const widthByField = {};
        visible.forEach((column, index) => {
            widthByField[getFirstField(column.field)] = minWidths[index] + q + (index < r ? 1 : 0);
        });

        setCurrentColumns((prev) => prev.map((column) => {
            const key = getFirstField(column.field);
            if (widthByField[key]) {
                return {...column, width: widthByField[key]};
            }
            return column;
        }));
    }, [containerWidth, currentColumns, excludeArray.target, checked]);

    const resetHeader = () => {
        // eslint-disable-next-line no-restricted-globals
        if(confirm("저장된 목록 순서를 초기화하시겠습니까?")) {
            resetIndividualSetting("headers", entity).then(r => {
                if (r.status === 200) {
                    alert('초기화 되었습니다.')
                    window.location.reload()
                } else {
                    alert('장애가 발생하였습니다.')
                }
            })
        }
    }

    const visibleColumns = currentColumns.filter((column) => !isExcluded(column.field, excludeArray.target));
    const getColumnWidth = (column) => {
        const width = Number(column?.width ?? column?.minWidth ?? 120);
        return Number.isFinite(width) ? Math.round(width) : 120;
    };
    const visibleColumnsWidth = visibleColumns.reduce((sum, column) => sum + getColumnWidth(column), 0);
    const fixedColumnsWidth = 60 + (checked ? 40 : 0); // No. + checkbox
    const baseWidth = visibleColumnsWidth + fixedColumnsWidth;
    const fillerWidth = Math.max((containerWidth || 0) - baseWidth, 0);
    const tableWidth = baseWidth + fillerWidth;

    return (
        <div>
            <div className="mb-2 relative">
                <span className="totalElements" onClick={() => console.log("")}>
                    총 {page.totalElements} 건
                </span>

                {(isSystem(user) || !listManage) && (
                    <>
                        {pin &&
                            <div className="absolute top-[2px] ml-[20px] cursor-pointer inline-flex items-center gap-1 whitespace-nowrap">
                                <img
                                    src={(!pin.on && pinned) ? Pin : pinned ? FilledPin : AvailablePin}
                                    className="w-[15px] h-[15px]"
                                    onClick={headerHandler}
                                />

                                <abbr title="헤더 초기화" className="leading-none ml-2">
                                    <FontAwesomeIcon
                                        icon={faRedo}
                                        onClick={resetHeader}
                                        className="text-[15px] text-[var(--main-bg-color)]"
                                    />
                                </abbr>
                            </div>
                        }
                        <div className="inline-block float-right" onClick={() => setFilterOpen(!filterOpen)}>
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                                 stroke="currentColor" className="w-6 h-6 inline-block">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M6 13.5V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m12-3V3.75m0 9.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 3.75V16.5m-6-9V3.75m0 3.75a1.5 1.5 0 0 1 0 3m0-3a1.5 1.5 0 0 0 0 3m0 9.75V10.5"/>
                            </svg>
                        </div>
                    </>
                )}
            </div>
            <div className={"table-border-top relative"}>
                {currentColumns && filterOpen &&
                    <HeaderModifier header={currentColumns} exArray={excludeArray.target} setExArray={excludeArray.fnc}
                                        setFilterOpen={setFilterOpen} setPinned={setPinned} />
                }
                <div
                    ref={tableContainerRef}
                    className={`relative w-full overflow-auto table-border bg-[var(--even-background)] ${height ? '' : "height-max"}`}
                    style={height ?? {}}>
                    <table
                        className="common-table caption-bottom"
                        style={{ width: `${tableWidth}px` }}
                    >
                        <colgroup>
                            {checked && <col style={{ width: '40px' }} />}
                            <col style={{ width: '60px' }} />
                            {visibleColumns.map((column, index) => (
                                <col key={`col_${getFirstField(column.field)}_${index}`} style={{ width: `${getColumnWidth(column)}px` }} />
                            ))}
                            <col style={{ width: `${fillerWidth}px` }} />
                        </colgroup>
                        <thead className="t-sticky common-table-th">
                        <tr>
                            {checked &&
                                <th style={{width: '40px', maxWidth: '40px'}}
                                    className="text-center chk-box-col border-1-deep-gray-not-left">
                                    <input
                                        checked={isHeaderChecked}
                                        onChange={handleHeaderCheckboxClick}
                                        type="checkbox"/>
                                </th>
                            }
                            <th className="common-table-th text-center " style={{width: '60px'}}>No.</th>
                            {currentColumns.map((column, index) => {
                                const styles = {};
                                if (column.minWidth) {
                                    styles.minWidth = column.minWidth + `px`;
                                }
                                if (column.width) {
                                    styles.width = column.width + `px`;
                                }
                                if (!isExcluded(column.field, excludeArray.target)
                                    // !excludeArray.target.includes(column.field)
                                    ) {
                                    return (
                                        <th className="common-table-th text-indent text-left relative" key={'th_' + index}
                                            style={styles}
                                            // 시스템권한이거나, 목록 제어 기준이 일반 사용자일 때
                                            {...((isSystem(user) || !listManage) ? { draggable: true } : {})}
                                            onDragStart={(e) => handleDragStart(e, index)}
                                            onDragOver={allowDrop}
                                            onDrop={(e) => handleDragOver(e, index)}
                                        >
                                            {column.name}
                                            { !column.unSort && handleSortChange &&
                                                <Sort handleSortChange={handleSortChange} pageInfo={page} target={Array.isArray(column.field) ? column.field[0]: column.field}/>
                                            }

                                            <div
                                                className="col-resizer"
                                                draggable={false}
                                                onMouseDown={(e) => onResizeStart(e, column.field)}
                                                // onDoubleClick={() => autoFitColumn(column.field)}
                                                title="드래그로 크기 조절"
                                            />
                                        </th>
                                    )}
                            })}
                            <th
                                aria-hidden="true"
                                className="common-table-th p-0 border-0"
                                style={{ width: `${fillerWidth}px`, minWidth: `${fillerWidth}px` }}
                            />
                        </tr>
                        </thead>

                        <tbody className="table-body">
                        {data && data.length > 0 ? (data.map((item, rowIndex) => (
                                <tr key={"r_"+rowIndex} className="cursor-pointer">
                                    {checked &&
                                        <td className="text-center border-1-deep-gray-not-left chk-box-col" onClick={(e) => {
                                            e.stopPropagation();
                                            handleCheckboxClick(item.id);
                                        }}>
                                            <input
                                                type="checkbox"
                                                checked={checked.checked && checked.checked.includes(item.id)}
                                                readOnly
                                                // onChange={() => handleCheckboxClick(item.id)}
                                            />
                                        </td>
                                    }
                                    <td className="border-1-deep-gray text-center h-[30px]">
                                        {page.totalElements - ((page.currentPage) * page.size + rowIndex)}
                                    </td>
                                    {currentColumns.map((th, colIndex) => (
                                        !isExcluded(th.field, excludeArray.target) && (
                                        // !excludeArray.target.includes(th.field) && (
                                            <td className="text-indent border-1-deep-gray truncate"
                                                key={"c_"+colIndex}
                                                onClick={(e) => {
                                                    if (th.type === 'blocked' || th.type === 'link') return;
                                                    th.button || goTo(item.id, item['linkUrl'], e);
                                                }}
                                            >

                                                {th.type === "image" &&
                                                    <div className="w-[30px] h-[30px] p-[2px]">
                                                        {item[th.field] ?
                                                            <img className="w-[26px] ml-[4px] block"
                                                                 src={`${IMG_BASE + item[th.field][0].path}${item[th.field][0].thumbnail ? 'thumb_' : ''}${item[th.field][0].uploadName}`}/>
                                                            :
                                                            <img className="w-[26px] ml-[4px] align-middle" src={NoImage}
                                                                 alt="이미지 설명"/>
                                                        }
                                                    </div>
                                                }

                                                {!th.renderer && !th.type &&
                                                    <p className={'truncate'} title={formatSimmsGridCell(th.field, getNestedValue(item, th.field, th.short))}>
                                                        {formatSimmsGridCell(th.field, getNestedValue(item, th.field, th.short))}
                                                    </p>
                                                }

                                                {th.type === "dateArray" && th.field.map((each, index) => {
                                                    const label = currentColumns[colIndex].label[index] ?? "";
                                                    const raw = item[th.field[index]];
                                                    const text = typeof raw === "string" ? formatSimmsDateTime(raw) : "";
                                                    return (
                                                        <p key={index}> {label + text}</p>
                                                    )
                                                })}

                                                {th.type === "objectArray" && th.field.map((each, index) => {
                                                    const label = currentColumns[colIndex].label[index] ?? "";
                                                    const value = getNestedValue(item, th.field[index], th.short) ?? "";
                                                    return (
                                                        <p key={index}> {`${label} ${value}`}</p>
                                                    )
                                                })}

                                                {th.renderer &&
                                                    <th.renderer keys={item.id} data={getInnerObject(item, th.field, th.short)} item={item}/>
                                                }

                                                {th.type === "link" &&
                                                    <>
                                                        <p className={`hover:underline`}
                                                           onClick={() => moveByLink(item, th.path, th.linkId, th.short)}
                                                        >
                                                            {th.field ? getNestedValue(item, th.field, th.short) : "바로가기"}
                                                        </p>
                                                    </>
                                                }

                                                {th.type === 'children' && (
                                                    <>
                                                        {(() => {
                                                            const matchedItem = item[th.field.split('_')[0]]?.find((each) => each.keyString === th.key);
                                                            return matchedItem?.valueString
                                                        })()}
                                                    </>
                                                )}

                                                {th.type === 'feedback' &&
                                                    <>
                                                        {item[th.field] !== 0 &&
                                                            <RatedStart
                                                                defaultValue={item[th.field]}
                                                                className={"justify-center"}
                                                            />
                                                        }
                                                    </>
                                                }
                                            </td>
                                        )))}
                                    <td className="p-0 border-0" style={{ width: `${fillerWidth}px`, minWidth: `${fillerWidth}px` }} />
                                </tr>
                            )))
                            : (
                                <tr className={`common-table-nodata-tr ${height ? '' : "height-max-tr"}`}>
                                    <td className="text-center"  colSpan={checked ? (currentColumns.length - excludeArray.target.length) + 3 : (currentColumns.length -  excludeArray.target.length) + 2}>
                                        <img src={EmptyData} className="w-[70px] m-auto mb-3"/>
                                        <span className="">내역이 없습니다.</span>
                                    </td>
                                </tr>
                            )}
                        </tbody>

                    </table>
                </div>
            </div>
            <ContentsDrawer id={selectedId} entity={entity}/>
        </div>
    );
}

export default SimmsTable;
